import { render, staticRenderFns } from "./CommentEditor.vue?vue&type=template&id=6c5e05f2"
import script from "./CommentEditor.vue?vue&type=script&lang=js"
export * from "./CommentEditor.vue?vue&type=script&lang=js"
import style0 from "./CommentEditor.vue?vue&type=style&index=0&id=6c5e05f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports